export const certificationData = [
    {
        title: "Frontend Development Specailization",
        platform: "Scrimba, Coursera",
        date: "06/2025",
        link: "https://coursera.org/share/904aa84faf4a0e0ee19cafc01c8eef14"
    },
    {
        title: "Google Cybersecurity Professional Certificate",
        platform: "Google, Coursera",
        date: "07/2024",
        link: "https://coursera.org/share/69f11ee7b9ff244e0b022a877078767b"
    },
    {
        title: "SQL(Intermediate)",
        school: "Hacker Rank",
        date: "10/2022",
        link: "https://www.hackerrank.com/certificates/iframe/ecab18a6d141"
    },
    {
        title: "SQL(Basic)",
        school: "Hacker Rank",
        date: "09/2022",
        link: "https://www.hackerrank.com/certificates/iframe/db2358005c97"
    },
    {
        title: "Python for DataScience",
        school: "NPTEL, Swayam",
        date: "08/2021"
    },
    {
        title: "C for EveryOne: Programming Fundamentals",
        school: "Coursera",
        date: "05/2021"
    },
]